<template>
  <md-card class="event-color-glossary w-[300px] m-0">
    <md-card-content>
      <div
        class="flex justify-between py-2"
        v-for="(bgColor, eventCategory) in eventBgColors"
        :key="eventCategory"
      >
        <span class="event-type-name text-md font-medium text-gray-700">
          {{ eventCategories[eventCategory] }}
        </span>
        <span
          :style="{ width: '23px', height: '23px', backgroundColor: bgColor }"
          class="rounded-full"
        ></span>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
import { BACKGROUND_COLORS, EVENT_CATEGORIES } from "./Event/event-utils";
export default {
  data() {
    return {
      eventBgColors: BACKGROUND_COLORS,
      eventCategories: EVENT_CATEGORIES
    };
  }
};
</script>

<style lang="scss" scoped></style>
